import { render, staticRenderFns } from "./NhstResetPasswordValidateCode.vue?vue&type=template&id=0995a3dc"
import script from "./NhstResetPasswordValidateCode.vue?vue&type=script&lang=js"
export * from "./NhstResetPasswordValidateCode.vue?vue&type=script&lang=js"
import style0 from "./NhstResetPasswordValidateCode.vue?vue&type=style&index=0&id=0995a3dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports